import React from 'react';
import bgImage from '../assets/blog/hero2.png';
import banner from '../assets/blog/card.png';
import card from '../assets/blog/card.png';
import { MdKeyboardArrowRight } from 'react-icons/md';

const cards = new Array(3).fill({
  image: card,
  title: 'How Might A Mobile App Help Your Non-Profit Company?',
  desc: "Initially, the purpose of mobile apps was to promote productivity by collecting contacts, scheduling emails, and managing calendars.by collecting contacts, scheduling emails, and managing calendars. inspired to produce apps for a variety of niches, including games, entertainment, social networks, and n...",
  link: '/read',
});

const SingleBlog = () => {
  return (
    <div className='flex flex-col gap-16'>
      {/* Hero Section */}
      <div
className='w-full h-[25vh] sm:h-[25vh] md:h-[50vh] lg:h-screen text-white flex justify-start items-center pt-24 relative bg-cover bg-center'
style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className='absolute inset-0 bg-gradient-to-r from-[#171f81]/[.33] to-[#c5cfeff0]/[.18] z-0'></div>
        <div className='flex flex-col gap-12 p-6 md:p-16 lg:p-28 z-10 w-full max-w-[1200px]'>
          <div className='w-full md:w-[700px]'>
            <p className='font-nunito text-[18px] md:text-[30px] lg:text-[48px] leading-tight text-left'>
              Blog: How might A Mobile app Help Your Non-Profit company?
            </p>
          </div>
        </div>
      </div>

      {/* Blog Title */}
      <p className='text-center text-2xl md:text-3xl font-semibold leading-[23.4px]'>BLOGs</p>

      {/* Blog Content */}
      <div className='px-4 sm:px-8 md:px-20 lg:px-28 flex flex-col gap-16'>
        <img src={banner} alt='banner' className='w-full rounded-lg max-h-[502px] object-cover' />
        <div className='border-2 p-4 sm:p-6 md:p-10 w-full text-[16px] text-[#3C4858] leading-relaxed'>
          <p><strong>Blog Author:</strong> Esparse Matrix Solutions</p>
          <p><strong>Posted on:</strong> 21-06-2023</p>
          <br />

          <p>
            Initially, the purpose of mobile apps was to promote productivity by collecting contacts, scheduling emails, and managing calendars. Because of their broad popularity, app developers have been inspired to produce apps for a variety of niches, including games, entertainment, social networks, and news.
          </p>
          <br />

          <p>
            Our non-profit organization's mobile app is a user-friendly platform that enables easy access to our mission, services, and engagement opportunities. With personalized content, push notifications, and interactive features, it actively connects users with our cause.
          </p>
          <br />

          <p>Here are some reasons why mobile apps for nonprofits are essential right now:</p>
          <br />

          <ol className='list-decimal pl-4 space-y-4'>
            <li>
              <strong>Increased Outreach:</strong> An app allows NGOs to reach a wider audience and engage with people who prefer using mobile devices...
            </li>
            <li>
              <strong>Enhanced Communication:</strong> An app gives the NGO and its stakeholders a simple and direct channel for communication...
            </li>
            <li>
              <strong>Donations & Fundraising:</strong> By offering a safe online transaction platform, an app can speed up the donation process...
            </li>
            <li>
              <strong>Management of Volunteers:</strong> An app can act as the central hub for managing volunteers...
            </li>
            <li>
              <strong>Access to Resources:</strong> A centralized platform for sharing and storing these resources can be offered through an app...
            </li>
            <li>
              <strong>Collection Of Data And Analysis:</strong> An app can help NGOs gather information about their operations, results, and beneficiaries...
            </li>
            <li>
              <strong>Mobilization and Advocacy:</strong> A strong tool for organizing supporters is an app that allows users to take part in campaigns...
            </li>
            <li>
              <strong>Community Building:</strong> Users may interact, work together, and share experiences with the help of services like discussion forums...
            </li>
          </ol>
          <br />

          <p>
            By utilizing the widespread availability of mobile devices and offering a smooth user experience, an app can dramatically improve an NGO's reach, communication, efficiency, and effect...
          </p>
          <br />

          <strong>Why is Esparse Matrix Solutions a perfect tech partner for your NGO?</strong>
          <br />
          <br />

          <p>
            Esparse Matrix Solutions is a privately held firm that provides software services with an emphasis on improving people's lives through cutting-edge technology...
          </p>
          <br />

          <p>
            Esparse Matrix Solutions, the industry leader in developing web and mobile applications for non-profit organizations, will advise you on the market, product, and business strategy...
          </p>
        </div>
      </div>

      {/* Related Posts */}
      <p className='text-center text-2xl md:text-3xl font-semibold leading-[23.4px]'>Related Posts..</p>
      <div className='flex flex-wrap gap-6 justify-center px-4 md:px-16 lg:px-28 mb-10'>
        {cards.map((c, index) => (
          <div
            key={index}
            className='w-full sm:w-[90%] md:w-[45%] lg:w-[30%] max-w-[400px] h-auto shadow-md rounded-md overflow-hidden'
          >
            <img src={c.image} className='w-full h-[195px] object-cover' alt='card' />
            <div className='flex flex-col p-4 gap-4'>
              <p className='text-[20px] font-bold text-left text-[#3C4858]'>{c.title}</p>
              <p className='text-[16px] text-left text-[#3C4858]'>{c.desc}</p>
              <div className='text-[#2F55D4] text-[16px] flex items-center gap-1'>
                <a href={c.link}>Read More</a>
                <MdKeyboardArrowRight className='text-[24px]' />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SingleBlog;
